/* app/ui/rotator/rotator */

define( 
	'app/ui/rotator/rotator',[
		'jquery',
		'brotator',
		'hammer',
		'actual'
	],

	function ( $ ) {

		var Rotator;
		var pane_count, pane_width, current_pane;
		var $items, $next, $prev;
		var $featureRotator = null;
		var $content = null;
		var $viewport = null;
		var autoRotate = false;
		var isLanding = false;
		var isSlide = false;

		var headingOverlayWidth = '1024px';
		var imageHeight = 530;
		var imageWidth = 1600;
		var imageWidthCropped = 1280;
		var originalRatio = imageWidth / imageHeight;
		var croppedRatio = imageWidthCropped / imageHeight;

		return {
			init: function () {
				Rotator = this;
				$featureRotator = $( '.js-rotator' );
				$content = $featureRotator.find( '.js-rotator__content' );
				$viewport = $featureRotator.find( '.js-rotator__viewport' );
				$items = $content.find( 'li' );
				$next = $featureRotator.find( '.js-rotator__next' );
				$prev = $featureRotator.find( '.js-rotator__prev' );
				autoRotate = $featureRotator.hasClass( 'is-auto' );
				isLanding = $featureRotator.hasClass( 'rotator--landing' );
				
				pane_count = $items.length;
				current_pane = 0;

				if(isLanding){
					imageHeight = 427;
					imageWidth = 1280;
					imageWidthCropped = 1280;
					originalRatio = imageWidth / imageHeight;
					croppedRatio = imageWidthCropped / imageHeight;
				}

				if ( $items.length > 1 ) {
					isSlide = $('html').hasClass('touch') && (!window.matchMedia || window.matchMedia('(max-width: 767px)').matches);
					$featureRotator.brotator( {
						content: '.js-rotator__content',
						timeout: 7000,
						hasMenu: true,
						hasButtons: true,
						next: '.js-rotator__next',
						previous: '.js-rotator__prev',
						menu: '.js-rotator__menu',
						menuItem: '.js-rotator__menu-item',
						animationSpeed: 300,
						lazyloader: true,
						namespace: '/rotator',
						autorotate: autoRotate,
						animation: isSlide ? 'slide' : 'fade',
						complete: function(i) {
							current_pane = i;
						}
					} );
					$featureRotator.find('.rotator__controls').css('display', 'block');
				} else {
					$featureRotator.addClass('no-controls');
				}
				$( window ).on( 'resize', $.throttle( 250, Rotator._setItemPadding) );
				$featureRotator.removeClass('rotator--loading');
				Rotator._setItemPadding();
				if(isSlide){
					$featureRotator.addClass('rotator--slide');
					$content.addClass('animate');
					Hammer($featureRotator[0], { drag_lock_to_axis: true }).on( "release dragleft dragright swipeleft swiperight", Rotator.handleHammer );
				}
				
			},
			_setItemPadding: function (event) {
				$featureRotator.each(function(index){
					$thisRotator = $(this);
					$viewport = $thisRotator.find( '.js-rotator__viewport' );
					$items = $viewport.find( 'li' );
					var $rotatorBody = $thisRotator.find('.rotator__body-content');
					var $figures = $viewport.find( '.figure' );
					var percentage;
					var width = $viewport.width();
					var biggestHeight = 0;
					var biggestBody = 0;
					$rotatorBody.css('height','');
					if(!!window.matchMedia && !window.matchMedia('(min-width: '+headingOverlayWidth+')').matches){
						$rotatorBody.each( function () {
							var height = $( this ).actual('outerHeight');
							if ( height > biggestBody ) {
								biggestBody = height;
							}
						} );
						$rotatorBody.css('height',biggestBody);
					}
					if(event){//is resize
						if(!isLanding && width < imageWidthCropped){
							var calcHeight = width / croppedRatio;
							var calcWidth = calcHeight * originalRatio;

							$figures.css({height: calcHeight, width: calcWidth, 'margin-left': -calcWidth/2});
							$items.css('padding-top', calcHeight);
						} else {
							$figures.css({height: '', width: '', 'margin-left': ''});
							$items.css('padding-top', '');
						}
					}

					$items.each( function () {
						var height = $( this ).outerHeight();
						if ( height > biggestHeight ) {
							biggestHeight = height;
						}
					} );
					//percentage = isLanding ? biggestHeight : ( biggestHeight / width ) * 100 + '%';

					$viewport.css( {
						paddingBottom: biggestHeight
					} );

					if(isSlide) {
						pane_width = width;
						$items.css({width: pane_width});
						$content.css({width: pane_width*pane_count});
					}
					
				});
			},

			stopAuto: function () {
				$featureRotator.brotator('stopAutoRotate');
			},

			setContainerOffset: function(offset, animate) {
				$content.removeClass( "animate" );
				if ( animate ) {
					$content.addClass( "animate" );
				}
				$content.css('left', offset+'%');
				
			},

			showPane: function(pane) {
				Rotator.setContainerOffset(-pane*100, true);
			},

			handleHammer: function ( ev ) {
				// disable browser scrolling
				ev.gesture.preventDefault();

				switch ( ev.type ) {
					case 'dragright':
					case 'dragleft':
						// stick to the finger
						var pane_offset = -( current_pane*100 );
						var drag_offset = (ev.gesture.deltaX / pane_width) * 100;

						// slow down at the first and last pane
						if ( ( current_pane === 0 && ev.gesture.direction == Hammer.DIRECTION_RIGHT ) ||
							( current_pane == pane_count - 1 && ev.gesture.direction == Hammer.DIRECTION_LEFT ) ) {
							drag_offset *= 0.4;
						}

						Rotator.setContainerOffset( drag_offset + pane_offset );
						break;

					case 'swipeleft':
						$content.addClass( "animate" );
						$next.click();
						ev.gesture.stopDetect();
						break;

					case 'swiperight':
						$content.addClass( "animate" );
						$prev.click();
						ev.gesture.stopDetect();
						break;

					case 'release':
						// more then 25% moved, navigate
						if ( Math.abs( ev.gesture.deltaX ) > pane_width / 4 ) {
							$content.addClass( "animate" );
							if ( ev.gesture.direction == 'left' ) {
								$next.click();
							} else {
								$prev.click();
							}
						}
						else {
							if(!$(ev.target).is('.js-rotator__next, .js-rotator__prev, .js-rotator__menu-item')) {
								Rotator.showPane( current_pane);
							}
						}
						break;
				}

				Rotator.stopAuto();
			}
		};
	}
);
